// extracted by mini-css-extract-plugin
export default {"iconWrapper":"BenefitIcon_iconWrapper__zRlF3","icon":"BenefitIcon_icon__KY-Dy"};